import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class CustomAccordion extends UcoastEl {
    static htmlSelector = 'custom-accordion'
    toggle: HTMLElement
    
    constructor() {
        super()
        this.toggle = q.rs('summary', this)

        this.toggle.addEventListener('click', (e) => {
            e.preventDefault()

            const content = this.toggle.nextElementSibling as HTMLElement
            if (!content) return

            const isOpening = !this.hasAttribute('open')

            this.toggleAttribute('open')
            this.toggle.setAttribute('aria-expanded', isOpening ? 'true' : 'false')

            if (isOpening) {
                // Opening
                content.style.height = '0px'
                content.classList.add('is-animating')

                const endHeight = content.scrollHeight

                // Force reflow
                content.offsetHeight

                content.style.height = endHeight + 'px'

                content.addEventListener('transitionend', () => {
                    content.classList.remove('is-animating')
                    content.style.height = 'auto'
                }, { once: true })

            } else {
                // Closing
                const startHeight = content.scrollHeight
                content.style.height = startHeight + 'px'
                content.classList.add('is-animating')

                // Force reflow
                content.offsetHeight

                content.style.height = '0px'

                content.addEventListener('transitionend', () => {
                    content.classList.remove('is-animating')
                    content.style.height = ''
                }, { once: true })
            }
        })
    }
}
